import type { Optional } from '@festina-life/core'
import { useLocalStorage } from '@festina-life/ui/hooks'
import { useCallback } from 'react'

import { useLayoutContext } from '../../context/layoutContext'
import { ACTIVE_BRANCH_ELEMENT_KEY } from './constants'
import type { BranchTreeElementKey } from './types'

export const useOpenActiveElement = () => {
  const [, setActiveElementKey] = useLocalStorage<
    Optional<BranchTreeElementKey>
  >(ACTIVE_BRANCH_ELEMENT_KEY)
  const { preferences, onChangeView } = useLayoutContext()

  return useCallback(
    (nextActiveElement: BranchTreeElementKey) => {
      const isBranchesPanelOpen = preferences.leftSidebar === 'branches'

      if (!isBranchesPanelOpen) {
        onChangeView({
          ...preferences,
          leftSidebar: 'branches',
        })
      }

      setActiveElementKey(nextActiveElement)
    },
    [onChangeView, preferences, setActiveElementKey],
  )
}
